import { publicPostApi } from "../../utils/apiHelper";
import { normalizeId } from "../../utils/organizationId";

function normalizeUserForStorage(user) {
  if (!user) return user;
  return {
    ...user,
    id: normalizeId(user.id),
    activeOrganizationId: normalizeId(user.activeOrganizationId),
  };
}

function normalizeOrganizationsForStorage(organizations) {
  if (!Array.isArray(organizations)) return organizations;
  return organizations.map((org) => ({
    ...org,
    id: normalizeId(org.id),
  }));
}

export const authValidate = (payload) => (dispatch) => {
  return new Promise((resolve, reject) => {
    publicPostApi("/auth/validate", payload)
      .then((response) => {
        if (response.status === 200) {
          const currentTime = new Date().getTime();
          const futureTime = 60000 * 60 * response.data.result.expireIn;
          localStorage.setItem("accessToken", response.data.result.accessToken);
          const user = normalizeUserForStorage(response.data.result.user || {});
          localStorage.setItem("user", JSON.stringify(user));
          if (response.data.result.organizations) {
            localStorage.setItem(
              "organizations",
              JSON.stringify(
                normalizeOrganizationsForStorage(
                  response.data.result.organizations,
                ),
              ),
            );
          } else {
            localStorage.setItem("organizations", JSON.stringify([]));
          }
          if (user.hasPassword || user.passwordHash) {
            localStorage.setItem("hasPassword", "true");
          } else {
            localStorage.removeItem("hasPassword");
          }
          if (response.data.result.emailSettings) {
            localStorage.setItem(
              "emailSettings",
              JSON.stringify(response.data.result.emailSettings),
            );
          } else {
            localStorage.removeItem("emailSettings");
          }
          localStorage.setItem(
            "expireAt",
            JSON.stringify(new Date(currentTime + futureTime).getTime()),
          );
          resolve();
        } else {
          reject(response.message);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const authRequest = (payload) => (dispatch) => {
  return new Promise((resolve, reject) => {
    publicPostApi("/auth/request", payload)
      .then((response) => {
        if (response.status === 200) {
          // do something
          resolve();
        } else {
          reject(response.message);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};
